const localStorageKeys = {
  i18nextLng: 'i18nextLng',
  photoRulesIntroShown: 'photoRulesIntroShown',
  addPhotoStepIntroShown: 'addPhotoStepIntroShown',
  changePhotoIntroShown: 'changePhotoIntroShown',
};

export default localStorageKeys;
